// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from '../../../store/store';

import {
  fetchPresetsForFamilyTree,
  fetchControlGroupById,
} from '../../../store/equipment/equipmentActions';

export async function controlLoader({ params }) {
  const { equipmentGroupId, cameraGroupId } = params;
  if (!equipmentGroupId || !cameraGroupId) {
    return null;
  }

  await Promise.all([
    store.dispatch(fetchControlGroupById(cameraGroupId)),

    store.dispatch(fetchPresetsForFamilyTree(equipmentGroupId)), // top level equipment group presets for family tree
  ]);

  return null;
}

controlLoader.hydrate = true;
